//export const host = "http://localhost:5000";
export const host = 'https://chathub-backend.onrender.com';
export const registerRoute = `${host}/api/auth/register`;
export const loginRoute = `${host}/api/auth/login`;
export const setAvatarRoute = `${host}/api/auth/setAvatar`;
export const allUsersRoute = `${host}/api/auth/allUsers`;
export const sendMessageRoute = `${host}/api/messages/addmsg`;
export const getAllMessagesRoute = `${host}/api/messages/getmsg`;
export const getTotalUsers = `${host}/api/auth/getTotalUsers`;
export const searchRoute = `${host}/api/auth/searchUsers`;
export const addFriendRoute = `${host}/api/friend/addFriend`;
export const getUserDetails = `${host}/api/auth/userDetails`;
export const updateUserProfile = `${host}/api/auth/updateDetails`;
export const updateAbout = `${host}/api/auth/updateAbout`;
export const verifyEmailForRegistration = `${host}/api/auth/verifyEmailForRegistration`;
export const verifyEmailForResetPassword = `${host}/api/auth/verifyEmailForResetPassword`;
export const resetPassword = `${host}/api/auth/resetPassword`;
export const deleteAccount = `${host}/api/auth/deleteAccount`;
